import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (username) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });
    const data = new FormData();
    data.append('username', username );
   
    const Authorization = UserToken;
    const url = ApiUrl2 + 'users-deactivate-account';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : data
    };

    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};